import React from 'react';
import { ClipboardListIcon, ShoppingCartIcon, BarChartIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: ClipboardListIcon,
    title: 'Assign Diet Plans',
    description: 'RDNs create and assign personalized therapeutic diet plans to patients through the Lola platform',
    color: 'bg-blue-100 text-blue-600'
  }, {
    icon: ShoppingCartIcon,
    title: 'Patients Shop Smart',
    description: 'Patients use Lola to shop from their local stores via Instacart with AI-powered recommendations that match their diet plan',
    color: 'bg-green-100 text-green-600'
  }, {
    icon: BarChartIcon,
    title: 'Monitor & Improve',
    description: 'Automatic logging updates RDNs on diet adherence in real-time, helping patients reach health metrics faster',
    color: 'bg-orange-100 text-orange-600'
  }];
  return <section className="py-20 bg-white" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="text-center mb-16" data-id="element-77">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-78">
            How Lola Works
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-79">
            Seamless integration between care teams and patients for better
            health outcomes
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-80">
          {steps.map((step, index) => <div key={index} className="relative" data-id="element-81">
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border-2 border-gray-100" data-id="element-82">
                <div className={`w-16 h-16 rounded-2xl ${step.color} flex items-center justify-center mb-6`} data-id="element-83">
                  <step.icon className="w-8 h-8" data-id="element-84" />
                </div>

                <div className="absolute -top-4 -right-4 w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center font-bold text-xl shadow-lg" data-id="element-85">
                  {index + 1}
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-86">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-87">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}